import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    FormFeedback,
    ModalHeader,
}                                                  from "reactstrap";
import React, {useContext, useState}               from "react";
import { useMutation , useQuery , useQueryClient } from "@tanstack/react-query";
import {toast}                                     from "react-toastify";
import Loader                                      from "../../components/Loader";
import AuthContext                                 from "../../context/AuthContext";
import handleUnauthorized401MutateError           from "../../utils/handleUnauthorized401MutateError";
import {addCoupon, getCustomers, getProducts} from "../../api/api";
import Select                                     from "react-select";
import handleUnauthorized401QueryError             from "../../utils/handleUnauthorized401QueryError";


const AddCouponButton = () => {
    const {refreshToken} = useContext(AuthContext)
    const [addCouponModal, setAddCouponModal] = useState(false);
    const toggleAddCouponModal = () => setAddCouponModal(!addCouponModal);

    const [couponName, setCouponName] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [couponValue, setCouponValue] = useState('');
    const [couponType, setCouponType] = useState('FLAT');
    const [couponPercentage, setCouponPercentage] = useState('');
    const [couponIsInventoryTrackingEnabled, setCouponIsInventoryTrackingEnabled] = useState(false);
    const [couponStock, setCouponStock] = useState('');
    const [couponMinimumCartValue, setCouponMinimumCartValue] = useState('');
    const [couponMaxValue, setCouponMaxValue] = useState('');
    const [couponEligibleForFirstOrder, setCouponEligibleForFirstOrder] = useState(false);
    const [couponApplicableTo, setCouponApplicableTo] = useState('CART-ITEM');
    const [customersSupported, setCustomersSupported] = useState([]);

    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerRecords, setCustomerRecords] = useState(1);

    const [productsSupported, setProductsSupported] = useState([]);

    const [productOptions, setProductOptions] = useState([]);
    const [productRecords, setProductRecords] = useState(1);
    const [advancedOptions, setAdvancedOptions] = useState(false);

    const page = 1;

    const queryClient = useQueryClient()

    const { refetch } = useQuery({
                                     queryKey: ['customers', customerRecords],
                                     queryFn: () => getCustomers(page,'', '','','', '', '','',
                                                                '', '','', customerRecords),
                                     keepPreviousData : true,
                                     retry: false,
                                     refetchOnWindowFocus: addCouponModal,
                                     enabled: addCouponModal,
                                     onSuccess: (data =>{
                                         setCustomerRecords(data?.count)
                                         let newOptions = []
                                         for(let i=0; i<data?.results?.length; i++){
                                             newOptions.push({value:data?.results[i].email, label:data?.results[i].email})
                                         }
                                         setCustomerOptions(newOptions)
                                     }),
                                     onError: (err => {
                                         handleUnauthorized401QueryError(err, refreshToken, refetch)
                                         if(err.response.status !== 401){
                                             toast.error(`An error occurred! ${err?.response?.data?.detail}`)
                                         }
                                     })
                                 })

    const { refetchProducts } = useQuery({
        queryKey: ['products', productRecords],
        queryFn: () => getProducts(page,'', '','','', '', '','',
            '', '','', '', '', '', '', productRecords),
        keepPreviousData : true,
        retry: false,
        refetchOnWindowFocus: addCouponModal,
        enabled: addCouponModal,
        onSuccess: (data =>{
            setProductRecords(data?.count)
            let newOptions = []
            for(let i=0; i<data?.results?.length; i++){
                newOptions.push({value:data?.results[i].name, label:data?.results[i].name})
            }
            setProductOptions(newOptions)
        }),
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetchProducts)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
    })

    const onSelectCustomer = (event) => {
        let newArr = event.map(e => e.value);
        setCustomersSupported(newArr);
    };

    const onSelectProducts = (event) => {
        let newArr = event.map(e => e.value);
        setProductsSupported(newArr);
    };

    const addCouponMutation = useMutation({
        mutationFn: addCoupon,
        onSuccess: (data, variables) =>{
            toggleAddCouponModal()
            queryClient.invalidateQueries(['coupons'])
            setCouponName('')
            setCouponCode('')
            setCouponValue('')
            setCouponType('FLAT')
            setCouponPercentage('')
            setCouponIsInventoryTrackingEnabled(false)
            setCouponStock('')
            setCouponMinimumCartValue('')
            setCouponMaxValue('')
            setCustomersSupported([]);
            setProductsSupported([]);
            setCouponEligibleForFirstOrder(false)
            setCouponApplicableTo('BOTH')
            setAdvancedOptions(false)
            toast.success('Coupon Added!')
        },
        // retry: true,
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, addCouponMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })


    const handleAddCouponFormSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", couponName);
        customersSupported.forEach(customer => {formData.append("eligible_customers", customer)})
        productsSupported.forEach(products => {formData.append("eligible_products", products)})
        formData.append("code", couponCode);
        formData.append("value", couponValue);
        formData.append("type", couponType);
        if(couponPercentage) formData.append("percentage", couponPercentage);
        formData.append("is_inventory_tracking_enabled", couponIsInventoryTrackingEnabled)
        if(couponStock) formData.append("stock", couponStock);
        if(couponMinimumCartValue) formData.append("minimum_cart_value", couponMinimumCartValue);
        if(couponMaxValue) formData.append("max_coupon_value", couponMaxValue);
        formData.append("eligible_for_first_order_only", couponEligibleForFirstOrder);
        formData.append("applicable_to", couponApplicableTo);
        formData.append("status", "ACTIVE");
        addCouponMutation.mutate(formData)
    };

    return (
        <>
            <div className="fileupload btn bx-btn-primary waves-effect waves-light mb-3" onClick={toggleAddCouponModal}>
                <span><i className="mdi mdi-plus-circle mr-1"/> Add Coupon</span>
            </div>

            <Modal isOpen={addCouponModal} toggle={toggleAddCouponModal}>
                <ModalHeader toggle={toggleAddCouponModal} close={
                    <button className="close" onClick={toggleAddCouponModal}>
                        &times;
                    </button>
                }>Add Coupon</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddCouponFormSubmit}>
                        <FormGroup>
                            <Label for="product-group-price">Code<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="coupon-code"
                                id="coupon-code"
                                placeholder="Coupon Code"
                                value={couponCode}
                                onChange={(e) =>
                                    setCouponCode(e.target.value)
                                }
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.code
                                }
                            />
                            {addCouponMutation.isError && addCouponMutation.error.response.data.code && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.code}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="coupon-type">Type<span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="coupon-type"
                                id="coupon-type"
                                className={"form-control"}
                                placeholder="Coupon Type"
                                value={couponType}
                                onChange={(e) =>
                                    setCouponType(e.target.value)
                                }
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.type
                                }
                            >
                                <option value={'FLAT'}>
                                    Flat
                                </option>
                                <option value={'PERCENTAGE'}>
                                    Percentage
                                </option>
                            </Input>
                            {addCouponMutation.isError && addCouponMutation.error.response.data.type && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.type}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        {couponType === 'PERCENTAGE' ? (
                            <FormGroup>
                                <Label for="coupon-percentage">Percentage<span className="text-danger">*</span></Label>
                                <Input
                                    type="text"
                                    name="coupon-percentage"
                                    id="coupon-percentage"
                                    placeholder="Coupon Percentage"
                                    value={couponPercentage}
                                    onChange={(e) => setCouponPercentage(e.target.value)}
                                    invalid={
                                        addCouponMutation.isError &&
                                        addCouponMutation.error.response.data.percentage
                                    }
                                />
                                {addCouponMutation.isError && addCouponMutation.error.response.data.percentage && (
                                    <FormFeedback invalid>
                                        {addCouponMutation.error.response.data.percentage}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        ) : null}

                        {/* Hide the "Value" input field when "Percentage" is selected */}
                        {couponType !== 'PERCENTAGE' && (
                            <FormGroup>
                                <Label for="coupon-value">Value<span className="text-danger">*</span></Label>
                                <Input
                                    type="text"
                                    name="coupon-value"
                                    id="coupon-value"
                                    placeholder="Coupon Value"
                                    value={couponValue}
                                    onChange={(e) => setCouponValue(e.target.value)}
                                    invalid={
                                        addCouponMutation.isError &&
                                        addCouponMutation.error.response.data.value
                                    }
                                />
                                {addCouponMutation.isError && addCouponMutation.error.response.data.value && (
                                    <FormFeedback invalid>
                                        {addCouponMutation.error.response.data.value}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                                <Input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkbox-advanced-options"
                                    checked={advancedOptions}
                                    onChange={() => setAdvancedOptions(!advancedOptions)}
                                />
                                <Label
                                    className="custom-control-label"
                                    for="checkbox-advanced-options"
                                >
                                    Advanced Options
                                </Label>
                            </div>
                        </FormGroup>
                        {advancedOptions&& (
                        <FormGroup>
                            <Label for="coupon-name">Coupon Name</Label>
                            <Input
                                type="text"
                                name="coupon-name"
                                id="coupon-name"
                                placeholder="Coupon Name"
                                value={couponName}
                                onChange={(e) =>
                                    setCouponName(e.target.value)
                                }
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.name
                                }
                            />
                            {addCouponMutation.isError && addCouponMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        )}
                        {advancedOptions&& (
                        <FormGroup>
                            <Label for="customers">
                                Select Customer (Ignore If Coupon is Universal)
                            </Label>
                            <Select
                                options={customerOptions}
                                isMulti
                                noOptionsMessage = {() => "No Customer(s) found!"}
                                placeholder = "Select Customers..."
                                defaultValue={customersSupported}
                                onChange={e => onSelectCustomer(e)}
                                styles={{
                                    control: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            borderColor: "#495561",
                                            backgroundColor: "#414d59",
                                            color: "white",
                                            padding: "0.45 0.9",
                                            border: 'none',
                                            boxShadow: 'none'
                                        }
                                    ),
                                    menu: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            backgroundColor: "#414d59",
                                            color: "#a8b5c3"
                                        }
                                    ),
                                    input: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            color: "white"
                                        }
                                    )
                                }}

                            />
                        </FormGroup>
                        )}
                        {advancedOptions&& (
                        <FormGroup>
                            <Label for="customers">
                                Select Products (Ignore If Coupon is Universal)
                            </Label>
                            <Select
                                options={productOptions}
                                isMulti
                                noOptionsMessage = {() => "No Product(s) found!"}
                                placeholder = "Select Products..."
                                defaultValue={productsSupported}
                                onChange={e => onSelectProducts(e)}
                                styles={{
                                    control: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            borderColor: "#495561",
                                            backgroundColor: "#414d59",
                                            color: "white",
                                            padding: "0.45 0.9",
                                            border: 'none',
                                            boxShadow: 'none'
                                        }
                                    ),
                                    menu: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            backgroundColor: "#414d59",
                                            color: "#a8b5c3"
                                        }
                                    ),
                                    input: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            color: "white"
                                        }
                                    )
                                }}

                            />
                        </FormGroup>
                        )}
                        {advancedOptions && couponType !== 'FLAT' && (
                        <FormGroup>
                            <Label for="coupon-max_value">Maximum Coupon Value</Label>
                            <Input
                                type="text"
                                name="coupon-max_value"
                                id="coupon-max_value"
                                placeholder="Coupon Max Value"
                                value={couponMaxValue}
                                onChange={(e) =>
                                    setCouponMaxValue(e.target.value)
                                }
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.max_value
                                }
                            />
                            {addCouponMutation.isError && addCouponMutation.error.response.data.max_value && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.max_value}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        )}
                        {advancedOptions&& (
                        <FormGroup>
                            <Label for="coupon-minimum_cart_value">Minimum Cart Value</Label>
                            <Input
                                type="text"
                                name="coupon-minimum_cart_value"
                                id="coupon-minimum_cart_value"
                                placeholder="Coupon Minimum Cart Value"
                                value={couponMinimumCartValue}
                                onChange={(e) =>
                                    setCouponMinimumCartValue(e.target.value)
                                }
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.minimum_cart_value
                                }
                            />
                            {addCouponMutation.isError && addCouponMutation.error.response.data.minimum_cart_value && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.minimum_cart_value}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup className="form-group mb-3">
                                <div className="custom-control custom-checkbox">
                                    <Input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="checkbox-inventory-tracking"
                                        checked={couponIsInventoryTrackingEnabled}
                                        onChange={() => setCouponIsInventoryTrackingEnabled(!couponIsInventoryTrackingEnabled)}
                                        invalid={
                                            addCouponMutation.isError &&
                                            addCouponMutation.error.response.data.is_inventory_tracking_enabled
                                        }
                                    />
                                    <Label
                                        className="custom-control-label"
                                        for="checkbox-inventory-tracking"
                                    >
                                        Inventory Tracking
                                    </Label>
                                    {addCouponMutation.isError && addCouponMutation.error.response.data.is_inventory_tracking_enabled && (
                                        <FormFeedback invalid>
                                            {addCouponMutation.error.response.data.is_inventory_tracking_enabled}
                                        </FormFeedback>
                                    )}
                                </div>
                            </FormGroup>
                        )}
                        {couponIsInventoryTrackingEnabled && advancedOptions&& (
                        <FormGroup>
                            <Label for="coupon-stock">Stock</Label>
                            <Input
                                type="text"
                                name="coupon-stock"
                                id="coupon-stock"
                                placeholder="Coupon Stock"
                                value={couponStock}
                                onChange={(e) =>
                                    setCouponStock(e.target.value)
                                }
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.stock
                                }
                            />
                            {addCouponMutation.isError && addCouponMutation.error.response.data.stock && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.stock}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        )}
                        {advancedOptions&& (
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                            <Input
                                type="checkbox"
                                className="custom-control-input"
                                id="coupon-firstOrder"
                                onChange={() => setCouponEligibleForFirstOrder(!couponEligibleForFirstOrder)}
                                invalid={
                                    addCouponMutation.isError &&
                                    addCouponMutation.error.response.data.eligible_for_first_order_only
                                }
                            />
                                <label
                                    className="custom-control-label"
                                    for="coupon-firstOrder"
                                >
                                    Eligible For First Order
                                </label>
                            </div>
                            {addCouponMutation.isError && addCouponMutation.error.response.data.eligible_for_first_order_only && (
                                <FormFeedback invalid>
                                    {addCouponMutation.error.response.data.eligible_for_first_order_only}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        )}
                        {/*{advancedOptions&& (*/}
                        {/*<FormGroup>*/}
                        {/*    <Label for="coupon-applicalbe">Applicable To</Label>*/}
                        {/*    /!*<p>Value - {couponApplicableTo}</p>*!/*/}
                        {/*    <Input*/}
                        {/*        type="select"*/}
                        {/*        name="coupon-applicalbe"*/}
                        {/*        id="coupon-applicable"*/}
                        {/*        className="form-control"*/}
                        {/*        placeholder="Coupon Applicalbe To"*/}
                        {/*        value={couponApplicableTo}*/}
                        {/*        onChange={(e) =>*/}
                        {/*            setCouponApplicableTo(e.target.value)*/}
                        {/*        }*/}
                        {/*        invalid={*/}
                        {/*            addCouponMutation.isError &&*/}
                        {/*            addCouponMutation.error.response.data.applicable_to*/}
                        {/*        }*/}
                        {/*    >*/}
                        {/*        <option value={'CART'}>*/}
                        {/*            Cart*/}
                        {/*        </option>*/}
                        {/*        <option value={'CART-ITEM'}>*/}
                        {/*            Cart Items*/}
                        {/*        </option>*/}
                        {/*        <option value={'BOTH'}>*/}
                        {/*            Both*/}
                        {/*        </option>*/}
                        {/*    </Input>*/}
                        {/*    {addCouponMutation.isError && addCouponMutation.error.response.data.applicable_to && (*/}
                        {/*        <FormFeedback invalid>*/}
                        {/*            {addCouponMutation.error.response.data.applicable_to}*/}
                        {/*        </FormFeedback>*/}
                        {/*    )}*/}
                        {/*</FormGroup>*/}
                        {/*)}*/}

                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={addCouponMutation.isLoading}
                        >
                            {addCouponMutation.isLoading? <><Loader size={'small'}/> Adding Coupon...</>: `Add Coupon`}

                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default AddCouponButton;